module.exports = __webpack_public_path__ + "img/ios_step1.5e49a339.png";